import XTbl, {Xtc} from '../../components/new-x-table/index';

const tbl = new XTbl('personelPastMonth/table', 'لیست پرسنل');
tbl.add(new Xtc('id', 'کد پرسنلی').filterText());
tbl.add(new Xtc('name', 'نام و نام خانوادگی').filterText())
tbl.add(new Xtc('contract_first.start_atj', 'تاریخ استخدام').filterDate().filterKey('created_at'))
export default tbl;
